import { FormGroup, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

export const requiredIfValidator = (sourceControlName: string): ValidatorFn => {
  return (group: AbstractControl): ValidationErrors | null => {
    const sourceChecked = group.get(sourceControlName)?.value;
    const targetControl = group.get('checkboxPurchaserGoogleAccountConfirmation');

    const targetControl2 = group.get('checkBoxMemberOfPrivacyClass');
    const targetControl3 = group.get('attestMemberOfPrivacyClass');
    const targetControl4 = group.get('attestMemberOfPrivacyClassSelection');
    const targetControl5 = group.get('checkBoxPrivacyCommunicationsRecorded');




    // If source is checked, the target must also be true
    if (sourceChecked && !targetControl?.value) {
      return { requiredIfFailed: true };
    }
    

    if (!sourceChecked && targetControl.value) {
      return { requiredIfFailed: true };
    }


    if (targetControl2.value && (!targetControl3?.value || !targetControl4?.value || !targetControl5?.value)) {
      return { requiredIfFailed: true };
    }

    if (!targetControl2?.value && (targetControl3.value || targetControl4.value || targetControl5.value)) {
      return { requiredIfFailed: true };
    }
    return null;
  };
};
